
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gcYTtPtSJyRgJNIvWvqqYWZvl4DkPJg6jMOjOX_zNb1wMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexh6rbzdiWdTErXcBe5v0OHlpiVcO_453nIWG4FG2tIv8MIMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchn2nTxaCP0JE_kac3h2HNTwaXVkk9r0WHioKb5cQhE4MMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexrgOcZx0l7tlXCkyjTYR2mWx_PzxX3btjkN9cGYZ1w5YMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93GcI3nP_45Rl3VZTwZ3qPfGVi9cscflDIPBhCh_aXPr8J8Meta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index0z5i5GwDrBh_45NhpgEcLet5hZ9G4EnN9MoJ36Oyf_45IAUMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_938MiK5xb1d2LhBafFBqmXRnrMLwQ58zdso0qVJ2wG8JMMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexhdc3VD6efTptw1ymnGFLXgK3iyYXgCwgj3_45HboqFi10Meta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93BwX4NwOPbJWUUFFHQHwHsUhmTrVyyvRh33pcoDi7Vr4Meta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexXHHCWa09bfMZw1OmdZE26Cgr2QGz6YOrN5805JTbbAQMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexOBY6m1ESWgdN0qfVgEZGs5u3tx2XsTFgRLX_M55WGmYMeta } from "/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index0z5i5GwDrBh_45NhpgEcLet5hZ9G4EnN9MoJ36Oyf_45IAUMeta || {},
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexhdc3VD6efTptw1ymnGFLXgK3iyYXgCwgj3_45HboqFi10Meta || {},
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexXHHCWa09bfMZw1OmdZE26Cgr2QGz6YOrN5805JTbbAQMeta || {},
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexOBY6m1ESWgdN0qfVgEZGs5u3tx2XsTFgRLX_M55WGmYMeta || {},
    component: () => import("/codebuild/output/src4148074378/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]